const { REACT_APP_SAS_SENHA, REACT_APP_SAS_URL } = process.env;

export const ConfigurarSas = () => {
  const returnSasToken = new Promise((resolve, reject) => {
    SasGetToken().then((result) => {
      const resultToken = JSON.parse(result.responseJSONData)["Token"];
      SasGetSession(resultToken).then((resultSession) => {
        resolve(JSON.parse(resultSession.responseJSONData)["SessionID"]);
      });
    });
  });

  return returnSasToken;
};

const SasGetToken = () => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("X-Login", "cotadorPME@omint.com.br");
  myHeaders.append("X-Senha", REACT_APP_SAS_SENHA);

  var raw = JSON.stringify({
    screenIdentification: "SASIO4D000001",
    userToken: "",
    Parameters: [],
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  return fetch(`${REACT_APP_SAS_URL}`, requestOptions).then((response) =>
    response.json()
  );
  // .then((result) => {
  //   return result.ResponseJSONData;
  // });
};

const SasGetSession = (token) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    screenIdentification: "SASIO4D000002",
    userToken: token,
    Parameters: [],
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(`${REACT_APP_SAS_URL}`, requestOptions).then((response) =>
    response.json()
  );
  // .then((result) => {
  //   return result.ResponseJSONData;
  // });
};
